import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/views/Login'
import Signup from '@/components/views/Signup'
import Validate from '@/components/views/Validate'
import PasswordReset from '@/components/views/PasswordReset'
import Settings from '@/components/views/Settings'
import SettingsProfile from '@/components/views/SettingsProfile'
import SettingsAccount from '@/components/views/SettingsAccount'
import Dashboard from '@/components/views/Dashboard'
import DashboardOverview from '@/components/views/DashboardOverview'
import DashboardForm from '@/components/views/DashboardForm'
import DashboardFormCreate from '@/components/views/DashboardFormCreate'
import DashboardFormSubmissions from '@/components/views/DashboardFormSubmissions'
import DashboardFormSubmissionsDetail from '@/components/views/DashboardFormSubmissionsDetail'
import DashboardFormSetup from '@/components/views/DashboardFormSetup'
import DashboardFormEdit from '@/components/views/DashboardFormEdit'
import DashboardFormNotifications from '@/components/views/DashboardFormNotifications'
import DashboardFormExport from '@/components/views/DashboardFormExport'

const STORAGE_TOKEN_ID = 'COOKIE_TOKEN_ID'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/validate/:token',
    name: 'Validate',
    component: Validate,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/reset/:token',
    name: 'PasswordReset',
    component: PasswordReset,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/settings',
    component: Settings,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'Settings',
        redirect: '/settings/profile',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'profile',
        name: 'SettingsProfile',
        component: SettingsProfile,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'account',
        name: 'SettingsAccount',
        component: SettingsAccount,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/',
    component: Dashboard,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'Dashboard',
        redirect: '/dashboard',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'dashboard',
        name: 'DashboardOverview',
        component: DashboardOverview,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'forms/create',
        name: 'DashboardFormCreate',
        component: DashboardFormCreate,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'forms/:form_id',
        component: DashboardForm,
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: '',
            name: 'DashboardForm',
            redirect: '/forms/:form_id/submissions',
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'submissions',
            name: 'DashboardFormSubmissions',
            component: DashboardFormSubmissions,
            meta: {
              requiresAuth: true
            },
            children: [
              {
                path: ':submission_id',
                name: 'DashboardFormSubmissionsDetail',
                component: DashboardFormSubmissionsDetail,
                meta: {
                  requiresAuth: true
                }
              }
            ]
          },
          {
            path: 'setup',
            name: 'DashboardFormSetup',
            component: DashboardFormSetup,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'edit',
            name: 'DashboardFormEdit',
            component: DashboardFormEdit,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'notifications',
            name: 'DashboardFormNotifications',
            component: DashboardFormNotifications,
            meta: {
              requiresAuth: true
            }
          },
          {
            path: 'export',
            name: 'DashboardFormExport',
            component: DashboardFormExport,
            meta: {
              requiresAuth: true
            }
          }
        ]
      }
    ]
  }
]

const isUserAuthenticated = () => {
  return !!localStorage.getItem(STORAGE_TOKEN_ID)
}

const authGuard = (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isUserAuthenticated()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
}

export function createRouter () {
  const router = new Router({
    routes,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }
      if (to.hash) {
        return { selector: to.hash }
      }
      return { x: 0, y: 0 }
    }
  })

  router.beforeEach(authGuard)

  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js